<template>
  <div id="OCApp">
    <router-view/>
    <notifications position="bottom right" />
  </div>
</template>

<script>
export default {
  	name: 'OCApp',
	mounted(){
		window.addEventListener("dragover",function(e){
		  e = e || event;
		  e.preventDefault();
		},false);
		window.addEventListener("drop",function(e){
		  e = e || event;
		  e.preventDefault();
		},false);
	},
	metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Dragonfly & Odonate Taxonomy and Sightings',
      // all titles will be injected into this template
      titleTemplate: 'Odonata Central - %s'
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue